import { Col, Row, } from "antd";
import ListItems from "./Components/ListItems";
import { FC } from "react";
import { useGetAdvertPriceHistories } from "../Ads/ServerSideStates";
import PageTitle from "apps/Common/PageTitle";



const TrackingPriceIndex:FC<{advertId?:string}> = ({advertId}) => {
  const histories = useGetAdvertPriceHistories(advertId||"")
  return (
    <>
      <Col xs={24} className="!mt-4">
        <Row gutter={[0, 20]} >
          <Col span={24} className="!flex justify-center">
          <PageTitle
          title="Fiyat Takibi"
          count={histories?.data?.data?.length||0}
          />
            
          </Col>

          <Col xs={24} className="">
            <ListItems advertId={advertId||""}/>
          </Col>
        </Row>
      </Col>
      <></>
    </>
  );
};

export default TrackingPriceIndex;
